import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_APPLICATION_WITH_WITHDRAWAL_STATUS} from '../../constants/apiUrls';
import {
  GET_NON_NATIONAL_APPLICATION_WITH_WITHDRAWAL_STATUS_QUERY_KEY
} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface NonNationalReviewApplicationWithWithdrawalResponse {
  editable: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: NonNationalReviewApplicationWithWithdrawalResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetNonNationalReviewApplicationWithWithdrawal = ({
                                                                   uuid,
                                                                   onSuccess,
                                                                   onError,
                                                                   enabled = true,
                                                                 }: Input) => {
  const getNonNationalReviewApplicationWithWithdrawal = async () => {
    const res = await axiosClient.get<NonNationalReviewApplicationWithWithdrawalResponse>(
        GET_NON_NATIONAL_APPLICATION_WITH_WITHDRAWAL_STATUS(uuid)
    );
    return res.data;
  };
  return useCustomQuery(
      [GET_NON_NATIONAL_APPLICATION_WITH_WITHDRAWAL_STATUS_QUERY_KEY, uuid],
      getNonNationalReviewApplicationWithWithdrawal,
      {
        onSuccess,
        onError,
        enabled,
      }
  );
};
